import { render, staticRenderFns } from "./CustomerAddressButton.vue?vue&type=template&id=523819b2"
import script from "./CustomerAddressButton.vue?vue&type=script&lang=js"
export * from "./CustomerAddressButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports